import { navigate } from "@reach/router"
import React, { useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import toastError from "../../../utils/toastError"
import {
  DiscoveryPage_InternalLink,
  Login_InternalLink,
} from "../../../utils/urls"
import syncProfileWithSessionStorage from "../../QueryUserProfile/syncProfileWithSessionStorage"
import { AskPCOSUserType, iPageContext } from "../../types"
import ArticlePageView from "./ArticlePageView"
import ShareArticleModal from "./ShareArticleModal"
import { getGlobalTranslations } from "./getGlobalTranslations"
import bookmarkArticle from "./utils/bookmarkArticle"
import isArticleBookmarked from "./utils/isArticleBookmarked"

const ArticlePage: React.FC<{
  pageContext: iPageContext
  userProfile: AskPCOSUserType | null
}> = ({ pageContext, userProfile }) => {
  const globalTranslations = getGlobalTranslations(pageContext.data.content)
  const [userProfileState, setUserProfileState] = useState<AskPCOSUserType>(
    null
  )
  const [bookmarked, setBookmarked] = useState<boolean>(false)
  const [bookmarkLoading, setBookmarkLoading] = useState(false)
  const [shareArticleModalOpen, setShareArticleModalOpen] = useState(false)

  useEffect(() => {
    setUserProfileState(userProfile)
  }, [])

  useEffect(() => {
    setBookmarked(isArticleBookmarked(userProfileState, pageContext))
  }, [userProfileState])

  const onClickBookmark = () => {
    if (bookmarkLoading) return
    if (!userProfileState) {
      navigate(Login_InternalLink)
      return
    }
    setBookmarkLoading(true)
    bookmarkArticle(userProfileState, pageContext.data.slug)
      .then(data => {
        setUserProfileState(data)
        setBookmarkLoading(false)
        syncProfileWithSessionStorage(data)
      })
      .catch(err => {
        console.error(err)
        setBookmarkLoading(false)
        toastError(toast, "Something went wrong...", "top-right")
      })
  }

  const onClickShare = () => {
    setShareArticleModalOpen(true)
  }

  const onRequestShareArticleModalClose = () => {
    setShareArticleModalOpen(false)
  }

  const onClickDiscussion = () => {
    console.log("discuss")
  }

  return (
    <>
      <ArticlePageView
        pageContext={pageContext}
        onClickDiscussion={onClickDiscussion}
        globalTranslations={globalTranslations}
        onClickBookmark={onClickBookmark}
        onClickShare={onClickShare}
        bookmarked={bookmarkLoading ? null : bookmarked}
        userProfile={userProfileState}
        breadcrumbs={[
          {
            link: DiscoveryPage_InternalLink,
            title: "Topics",
          },
          {
            link: `/topics/${pageContext.topic.slug}`,
            title: pageContext.topic.title,
          },
        ]}
      />
      <ShareArticleModal
        isOpen={shareArticleModalOpen}
        onRequestClose={onRequestShareArticleModalClose}
        quote={pageContext.data.title}
      />
      <ToastContainer />
    </>
  )
}

export default ArticlePage
